import { createAction, createFeatureSelector, createReducer, on, props } from "@ngrx/store"
import { State } from "."

export const statusStateFeatureKey =  'status'

export interface StatusState {
  [key: string]: 'VALID' | 'INVALID' | 'PENDING' | 'DISABLED'
}

export const updateStatusStateAction = createAction(
  '[Form Core Module] Update Status State',
  props<StatusState>()
)

const initialStatusState: StatusState = {}

export const statusStateReducer = createReducer(
  initialStatusState,
  on(updateStatusStateAction, (state, action) => {
    const obj = {...state}
    for (let path in action) {
      if (path !== 'type') obj[path] = action[path]
    }
    return obj
  })
)

export const selectStatus = createFeatureSelector<State, StatusState>(statusStateFeatureKey)